export default __webpack_public_path__ + "static/media/icon-web.256ded55.svg";